import React, { Component } from 'react';
import Media from "react-media";
import { SCREEN_WIDTH } from '../../App.js';
import { translate } from 'react-i18next';

class Rooms extends Component {


  renderRoom = (room, index) => {
    const { t } = this.props;

    return (
      <div className="col-xl-12 col-lg-12 col-md-6 col-sm-6 col-6 card-panel-rooms" key={index}>
        <div className="card-panel panel panel-default card">
          <div className="panel-heading" style={{ backgroundImage: "url('" + room.picture + "')" }}>
          </div>
          <div className="card-panel-body">
            <div className="panel-body-title">
              <h4 className="iossala">{room.name}</h4>
            </div>
            <div className="panel-body-description">
              <div className="panel-description-text">
                {room.description}
              </div>
              <div className="panel-description-information">
                <div className="contenedor-flexbox">
                  <div className="contenedor">
                    <i className="fa fa-users" aria-hidden="true">
                    </i>
                    Capacidad para {room.capacity} personas.
                  </div>
                </div>
                <div className="contenedor-flexbox">
                  {this.props.user.balance === undefined
                    ? (<div className="contenedor">
                      <i className="fa fa-usd" aria-hidden="true"></i>
                      {t('dashboard.reservations.price') + " $" + room.price}
                    </div>)
                    : (null)
                  }
                </div>
              </div>
            </div>
            <div className="panel-body-bottom">
              <div className="panel-body form-group">
                <button
                  className="btn btn-primary btn-singup"
                  onClick={() => { this.props.handleRoomClick(room); }}
                  type="button">
                  {t('dashboard.reservations.btn_book')}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  render() {
    const rooms = this.props.rooms;
    return (
      <div className="list-card-resvations">
        <div className="list-card-panel-seccion">
          <div className="content-card-panel-seccion">
            <Media query={"(min-width: " + SCREEN_WIDTH.LARGE + "px)"}>
              {(matches) =>
                matches ? (
                  rooms.map((_, index) => !(index % 2) &&
                    <div className="row list list2" key={index}>
                      {this.renderRoom(rooms[index], index)}
                      {rooms[index + 1] && this.renderRoom(rooms[index + 1], index + 1)}
                    </div>
                  )
                ) : (
                  rooms.map((_, index) => !(index % 2) &&
                    <div className="row list list3" key={index}>
                      {this.renderRoom(rooms[index], index)}
                      {rooms[index + 1] && this.renderRoom(rooms[index + 1], index + 1)}
                    </div>
                  )
                )
              }
            </Media>
          </div>
        </div>
      </div>
    );
  }
}

export default translate('common')(Rooms);



// WEBPACK FOOTER //
// ./src/dashboard/reservations/Rooms.js